// CSRF protection only: this value cannot authenticate without the HttpOnly cookie.
let csrfToken: string | null = null;
let revision = 0;
export const getCsrfToken = () => csrfToken;
export const getSessionRevision = () => revision;
export const setCsrfToken = (value: string | null) => { csrfToken = value; revision += 1; };
export const SESSION_EXPIRED_EVENT = "insecta:session-expired";
